<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-chart-bubble" class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Índices COGE :: {{ mesSelected }}</div>
      </template>

      <v-alert dense outlined type="info" color="blue" class="mt-5 px-1 py-0">
        Essa página exibe no máximo 1000 registros. Caso queira visualizar os Índices COGE completos para essa data,
        <a href="javascript:void(0)" @click="download()">clique aqui</a>
        para exportar em CSV.
      </v-alert>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-indice-coge ml-auto"
        label="Procurar"
        hide-details
        single-line
      />

      <v-divider class="mt-10" />

      <v-data-table
        :headers="headers"
        :loading="loading"
        :items="indices"
        :headerProps="{ sortByText: 'Ordenar Por' }"
        :footer-props="{ itemsPerPageText: 'Itens por Página' }"
        :search.sync="search"
        no-data-text="Nenhum índice disponível"
        no-results-text="Nenhum registro correspondente encontrado"
      >
        <template v-slot:[`item.coge`]="{ item }">
          {{ item.COGE }}
        </template>
        <template v-slot:[`item.VariacaoMes`]="{ item }">
          {{ item.VariacaoMes }}
        </template>
        <template v-slot:[`item.IndiceMes`]="{ item }">
          {{ item.IndiceMes }}
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
<script>
  import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';
  import IndicesCOGE from '@/services/IndicesCOGEService';

  export default {
    name: 'IdicesDataTable',
    mixins: [DateFormatterMixins],
    props: {
      indices: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'COGE',
          value: 'coge'
        },
        {
          text: 'Variação Mês',
          value: 'VariacaoMes'
        },
        {
          text: 'Índice Mês',
          value: 'IndiceMes'
        }
      ]
    }),

    computed: {
      mesSelected() {
        return this.formatDate(this.$route.params.data_registro);
      }
    },

    methods: {
      download() {
        const data_registro = this.$route.params.data_registro;

        this.$toast.info(`Gerando arquivo para download...`, '', { position: 'topRight', timeout: 2000 });
        IndicesCOGE.exportar(data_registro)
          .then(async (response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `indice-coge-${data_registro}.csv`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            this.$toast.error('Erro ao disponibilizar o download', '', { position: 'topRight' });
            console.error(err);
          });
      }
    }
  };
</script>

<style>
  @media screen and (max-width: 480px) {
    .bs-indice-coge {
      width: 209.91px !important;
    }
  }
</style>